import React, { useState } from "react";
import { Box, Typography, Button, Toolbar } from "@mui/material";
import CustomPopper from "../componentes/poppers/Custom_popper";

const RightGeneral = ({view, clicVista}) => {
  const [cajamodal, setCajamodal] = useState([]);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedButton, setSelectedButton] = useState(view); 

  const diccionarioBotones = [
    { id: "DiccionarioClientes", label: "Clientes" },
    { id: "DiccionarioCodigoGen", label: "Código General" },
    { id: "DiccionarioCodigoEsp", label: "Código Específico" },
  ];

  const handleClick = (vista) => {
    setSelectedButton(vista);  
    localStorage.setItem("view", vista);
    clicVista();
  };

  const handleDiccionariosClick = (event, vista) => {
    setCajamodal(diccionarioBotones);
    setAnchorEl(event.currentTarget);
    setOpen((prev) => !prev);
    handleClick(vista)
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ width: 200, bgcolor: "secondary.lateral", p: 2, display: "flex", flexDirection: "column",
        alignItems: "center", boxShadow: "-2px 0 5px rgba(0,0,0,0.1)", position: "sticky", top: 0, }}
    >
      <Toolbar />
      <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
        OPCIONES
      </Typography>
      {[
        { id: "procesador", label: "Procesador documentos" },
        { id: "soportes", label: "Explorador de archivo" },
        { id: "FacturasRd", label: "Analizar glosas" },
        { id: "Contestaciones", label: "Respuesta a glosas" },
        { id: "diccionarios", label: "Diccionarios" },
        { id: "informes", label: "Informes" },
        { id: "consultas", label: "Consultas" },
      ].map((button) => (
        <Button key={button.id}
          sx={{ mt: 2, width: 130, lineHeight: 1.2, bgcolor: selectedButton === button.id ? "primary.main" : "secondary.main", color: "white", 
            "&:hover": {
              bgcolor: "primary.dark",
              color: "white",
            },
          }}
          color="secondary" variant="contained" 
          onClick={(event) =>
            button.id === "diccionarios" ? handleDiccionariosClick(event, button.id) : handleClick(button.id)
          }
        >
          {button.label}
        </Button>
      ))}
      <CustomPopper open={open} anchorEl={anchorEl} cajamodal={cajamodal} handleClose={handleClose} funcionVista={clicVista} />
    </Box>
  );
};

export default RightGeneral;
